import React from "react";
import styles from "./addNewBpmnItem/AddNewBpmnItem.module.scss"

const AddNewBpmnItem = ({ handleTriggerShowModal }) => {

  return (
    <div onClick={handleTriggerShowModal} className={[styles.AddNewBpmnItem, 'col-sm-4 col-md-2'].join(' ')}>
      <div className={[styles.content, 'd-flex align-items-center justify-content-center'].join(' ')}>
        <span>ADD NEW BPMN MODEL</span>
      </div>
    </div>
  )
};

export default AddNewBpmnItem;